import React from 'react';
import { ErrorMessage, FastField } from 'formik';
import { formErrorMessage } from './FormErrorMessage';
import Dropzone from '../dropzone/Dropzone';
import StyledText from '../styledComponents/StyledText';

const FormikDropZone = ({
  name,
  onDrop,
  label = ' Drag a Photo or',
  isContent = true,
  size,
  accept,
  ...props
}) => {
  return (
    <FastField name={name} {...props}>
      {({ field, form: { submitCount, errors, ...props } }) => (
        <>
          <Dropzone
            {...props}
            size={size}
            name={name}
            accept={accept}
            isinvalid={submitCount && !!errors[field.name]}
            onDrop={onDrop}
            label={
              <StyledText color="heading" as="p" className={'mb-0'}>
                {label}
              </StyledText>
            }
            content={
              isContent ? (
                <StyledText color="primary" className={'mb-0'}>
                  Browse
                </StyledText>
              ) : (
                <></>
              )
            }
          />
          <ErrorMessage name={field.name} render={formErrorMessage} />
        </>
      )}
    </FastField>
  );
};

export default React.memo(FormikDropZone);
